/**
 * cortex-admin の auth API contract（me / logout）。
 * OAuth 開始は Edge Router Worker が配信するため、本 API / oRPC の対象外。
 *
 * @graph-stack cortex-admin
 * @graph-domain Engineering
 * @graph-business cortex-admin の現在ユーザー取得 / ログアウトの API ↔ Web 型を共有する。
 * @graph-connects @cortex/core-types [references] PortalRole の SSOT
 */
import { PORTAL_ROLES } from '@cortex/core-types';
import { z } from 'zod';
/** ポータルロール。 @graph-connects @cortex/core-types [references] core-types の PortalRole SSOT */
export const PortalRoleSchema = z.enum([...PORTAL_ROLES]);
/** 現在のセッションユーザー。 @graph-connects none */
export const AuthUserSchema = z.object({
    id: z.string(),
    email: z.email(),
    name: z.string(),
    picture: z.url().optional(),
    portalRole: PortalRoleSchema.optional(),
    teamName: z.string().optional(),
    slackId: z.string().optional(),
    isPipelineAdmin: z.boolean(),
    isWorkspacePermissionAdmin: z.boolean(),
    canRegisterQuery: z.boolean(),
    canUseSnsContentGenerator: z.boolean(),
});
/** 現在のユーザーレスポンス。 @graph-connects none */
export const CurrentUserResponseSchema = z.object({
    user: AuthUserSchema,
    expiresAt: z.iso.datetime(),
});
/** ログアウトレスポンス。 @graph-connects none */
export const LogoutResponseSchema = z.object({
    success: z.boolean(),
    message: z.string(),
});
//# sourceMappingURL=auth.js.map